import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-652f107a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "site-map-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Site Map", -1))
const _hoisted_3 = { class: "section-title" }
const _hoisted_4 = { class: "item" }
const _hoisted_5 = { class: "item" }
const _hoisted_6 = { class: "item" }
const _hoisted_7 = { class: "item" }
const _hoisted_8 = { class: "item" }
const _hoisted_9 = { class: "item" }
const _hoisted_10 = { class: "section-title" }
const _hoisted_11 = { class: "item" }
const _hoisted_12 = { class: "section-title" }
const _hoisted_13 = { class: "item" }
const _hoisted_14 = { class: "section-title" }
const _hoisted_15 = { class: "item" }
const _hoisted_16 = { class: "section-title" }
const _hoisted_17 = { class: "item" }
const _hoisted_18 = { class: "item" }
const _hoisted_19 = { class: "item" }
const _hoisted_20 = { class: "section-title" }
const _hoisted_21 = { class: "item" }
const _hoisted_22 = {
  href: "https://www.teladochealth.com/terms-of-service/",
  target: "_blank"
}
const _hoisted_23 = { class: "item" }
const _hoisted_24 = {
  href: "https://www.teladoc.com/notice-of-privacy-practices/",
  target: "_blank"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("h5", _hoisted_3, [
      _createTextVNode(_toDisplayString(_ctx.$t('account')), 1),
      _createElementVNode("li", _hoisted_4, [
        _createVNode(_component_router_link, { to: {path: '/profile'} }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('profile')), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_5, [
        _createVNode(_component_router_link, { to: {name: 'Notifications'} }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('notifications')), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_6, [
        _createVNode(_component_router_link, { to: {name: 'Language'} }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('language')), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_7, [
        _createVNode(_component_router_link, { to: {name: 'Personalization'} }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('personalization')), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_8, [
        _createVNode(_component_router_link, { to: {name: 'Support'} }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('support')), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_9, [
        _createVNode(_component_router_link, { to: {name: 'History'} }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('history')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("h5", _hoisted_10, [
      _createTextVNode(_toDisplayString(_ctx.$t('home')), 1),
      _createElementVNode("li", _hoisted_11, [
        _createVNode(_component_router_link, { to: {name: 'Home'} }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('home')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("h5", _hoisted_12, [
      _createTextVNode(_toDisplayString(_ctx.$t('connect')), 1),
      _createElementVNode("li", _hoisted_13, [
        _createVNode(_component_router_link, {
          to: {name: _ctx.connectNavName}
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('connect')), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ]),
    _createElementVNode("h5", _hoisted_14, [
      _createTextVNode(_toDisplayString(_ctx.$t('helpResources')), 1),
      _createElementVNode("li", _hoisted_15, [
        _createVNode(_component_router_link, { to: {name: 'HelpResources'} }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('helpResources')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("h5", _hoisted_16, [
      _createTextVNode(_toDisplayString(_ctx.$t('Explore')), 1),
      _createElementVNode("li", _hoisted_17, [
        _createVNode(_component_router_link, { to: {name: 'Explore'} }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('explore')), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_18, [
        _createVNode(_component_router_link, { to: {name: 'Search'} }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('search')), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_19, [
        _createVNode(_component_router_link, { to: {name: 'Browse'} }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Browse')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("h5", _hoisted_20, [
      _createTextVNode(_toDisplayString(_ctx.$t('Legal')), 1),
      _createElementVNode("li", _hoisted_21, [
        _createElementVNode("a", _hoisted_22, _toDisplayString(_ctx.$t('termsOfUse')), 1)
      ]),
      _createElementVNode("li", _hoisted_23, [
        _createElementVNode("a", _hoisted_24, _toDisplayString(_ctx.$t('privacyPolicy')), 1)
      ])
    ])
  ]))
}